import styled from 'styled-components'

export const List = styled.ul`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0;
    flex-basis: 300px;
    text-align: left;
    font-size: 12px;
        
    & > li
    {
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }
    
    
    li a
    {
        display: inline-flex;
        box-sizing: border-box;
        align-items: center;
        padding: 4px;
        min-height: 26px;
        min-width: 26px;
        justify-content: center;
        border-radius: 64px;
        background-color: transparent;
        color: #000;
        font-family: 'Noto Sans', sans-serif;
        font-weight: 400;
        font-size: 14px;
        line-height: 18px;
        letter-spacing: 0px;
        text-decoration: none;
        cursor: pointer;
        transition: all 0.2s ease;
    }
    
    li.active a
    {
        background-color: #D7DBE0 !important;
        color: #000;
    }
    
    li a:hover
    {
        color: #fff !important;
        background-color: #4378FF !important;
    }
    
    li.hidden
    {
        display: none!important;
    }
    
    li.disabled
    {
        
    }
`